// extracted by mini-css-extract-plugin
module.exports = {"order":"orders_order__2zG9V","details":"orders_details__3NWbf"};